import { render, staticRenderFns } from "./DoorBrokenTileSize.vue?vue&type=template&id=240f8ade&scoped=true"
import script from "./DoorBrokenTileSize.vue?vue&type=script&lang=ts"
export * from "./DoorBrokenTileSize.vue?vue&type=script&lang=ts"
import style0 from "./DoorBrokenTileSize.vue?vue&type=style&index=0&id=240f8ade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f8ade",
  null
  
)

export default component.exports